<template>
  <div class="backgroud-white cs-courseSchedule-editor" v-loading.fullscreen.lock="isLoading" element-loading-text="正在与ClassIn平台交互，创建课程及其所属学生，请耐心等待">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form ref="model" :rules="rules" :model="model" label-width="100px">
        <el-form-item label="学校" v-if="data.courseType == 1" size="mini">
          <label class="input-width">{{data.universityName}}</label>
        </el-form-item>
        <el-form-item label="课程" size="mini">
          <label class="input-width">{{data.courseName}}</label>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-select
            v-model="model.startTime"
            :clearable="true"
            size="small"
            placeholder="开始时间"
            :disabled="startTimeDisabled"
          >
            <el-option
              v-for="item in timesOfStartTime"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程时长" prop="hours">
          <el-select
            class="input-width"
            @change="checkAllInputs"
            v-model="model.hours"
            placeholder="请选择课程时长"
          >
            <el-option
              v-for="(item, index) in courseHourList"
              :key="index"
              :label="getHourLabel(item)"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="免计签到" prop="skipSignIn"  size="mini" v-show="false">
          <el-checkbox @change="checkAllInputs" v-model="model.skipSignIn" class="input-width"></el-checkbox>
        </el-form-item>
         <el-form-item label="课程类型" prop="courseCategory">
          <el-select
            class="input-width"
            @change="checkAllInputs"
            v-model="model.courseCategory"
            placeholder="请选择课程类型"
          >
            <el-option
              v-for="item in courseCategoryList"
              :key="item.Key"
              :label="item.Value"
              :value="item.Key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程介绍" prop="description">
          <el-input
            @change="checkAllInputs"
            type="textarea"
            :rows="5"
            placeholder="请输入课程介绍"
            v-model="model.description"
            class="input-width"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="18" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col class="footer-right" :span="6">
          <el-button
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="save()"
          >激活课程</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
body .popup-content-area-small{
  padding-top: 30px;
  padding-bottom: 20px;
}
</style>

<script>
import { activateOnlineCourse } from "../../service/teacherCourse.service.js";
import { getCourseCategoryList } from "../../service/common.service.js";
import { srcTimesOfDay } from "../../service/api-base.service";
let moment = require("moment");

export default {
  props: {
    data: {
      courseType: Number,
      universityName: String,
      courseName: String,
      teacherId: Number,
      courseId: Number,
      campusId: Number,
      courseCategory: Number
    }
  },
  data() {
    let _self = this;
    let startTimeValidator = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请选择开始时间"));
      } else {
        return callback();
      }
    };

    return {
      model: {
        startTime: "",
        hours: 2.5,
        skipSignIn: false,
        description: "",
        courseCategory: 1,
      },
      allCourseCategoryList: [],
      courseCategoryList: [],
      startTimeDisabled: false,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      showError: false,
      errorMessage: "",
      courseHourList: [],
      timesOfStartTime: [],
      timesOfDays: srcTimesOfDay(false, 0, 24),
      isLoading: true,
      rules: {
        startTime: [
          {
            validator: startTimeValidator,
            trigger: "blur"
          }
        ],
        hours: [
          {
            required: true,
            message: "请选择课程时长",
            trigger: "blur"
          }
        ],
        description: [
          {
            required: true,
            message: "请输入课程简介",
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {},
  created() {
    this.courseHourList = [1, 1.5, 2, 2.5,3, 3.5,4, 4.5,5,5.5, 6];
    this.loadTimesOfStartTime();
    getCourseCategoryList(1).then(result =>{
      if (!!result && result.success){
        this.allCourseCategoryList = result.data;
        //list.splice(list.findIndex(item => item.Key == 2), 1)
        //this.courseCategoryList = list;
        this.init();
        this.isLoading = false;
      }
    });
  },
  methods: {
    loadTimesOfStartTime() {
      let list = [];
      let currentTimeObj = new Date();
      let hour = currentTimeObj.getHours();
      let minute = currentTimeObj.getMinutes();
      let currentValue = hour * 60 + minute + 5;
      let value = -1;
      this.timesOfDays.forEach(element => {
        let item = {
          label: element.label,
          value: element.value,
          disabled: false
        };
        if (element.value < currentValue) {
          item.disabled = true;
        }
        list.push(item);
        if (!item.disabled && value < 0) {
          value = element.value;
        }
      });
      if (value < 0) {
        value = "";
      }
      this.timesOfStartTime = list;
      this.model.startTime = value;
    },
    getHourLabel(h) {
      return h + "小时";
    },
    checkAllInputs() {
      let isValid = true;
      this.$refs.model.validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      if (isValid) {
        //this.submitBtnClass = "primary";
        //this.submitBtnDisable = false;
      } else {
        //this.submitBtnClass = "info";
        //this.submitBtnDisable = true;
      }
    },
    save() {
      if (!!this.$refs["model"]) {
        let isValid = true;
        this.$refs["model"].validate(valid => {
          if (valid) {
          } else {
            isValid = false;
          }
        });
        if (!isValid) {
          return false;
        }

        let msg = "您确定要激活 " + this.data.courseName;
        if (this.model.skipSignIn){
          msg += "(免计签到)";
        }
        msg += " 这门线上课程吗？"; 
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            //console.log("是否有签到", !this.model.skipSignIn);
            //return;

            this.submitBtnDisable = true;
            this.isLoading = true;
            let date = moment().format("L");
            let hour = Math.floor(this.model.startTime / 60);
            let mintue = Math.floor(this.model.startTime % 60);
 
            if (hour == 24){
              date = moment().add(1, 'days').format("L");
              hour = 0;
            }
            let startTimeText = date + " " + hour + ":" + mintue;

            //return;
            activateOnlineCourse(
              this.data.teacherId,
              this.data.courseId,
              this.data.campusId,
              startTimeText,
              this.model.hours,
              this.model.description,
              !this.model.skipSignIn,
              this.model.courseCategory
            )
              .then(result => {
                if (result && result.success) {
                  let msg = "课程" + this.data.courseName + "已激活成功！";
                  if (!!result.data.Message) {
                    msg += result.data.Message;
                  }
                  this.$message(msg);
                  this.$emit("success", Object.assign({}, result.data, { StartTimeText: startTimeText }));
                } else {
                  this.errorMessage = result.message;
                  this.showError = true;
                }
                this.isLoading = false;
                this.submitBtnDisable = false;
              })
              .catch(() => {
                this.isLoading = false;
                this.submitBtnDisable = false;
              });
          })
          .catch(() => {
            this.proccessing = false;
          });
      }
    },
    close() {
      this.$emit("closeDialog");
    },
    init(){
      this.model.hours = 2.5;
      this.model.skipSignIn = false;
      this.model.description = "";
      let courseCategory = 1;
      if (this.data && this.data.courseCategory){
        courseCategory = this.data.courseCategory;
        // let index = this.courseCategoryList.findIndex(i => i.Key === this.data.courseCategory);
        // if (index >= 0){
        //   this.model.courseCategory = this.data.courseCategory;
        // }else{
        //   this.model.courseCategory = 1;
        // }
      }else{
        this.courseCategoryList = this.allCourseCategoryList.filter(i => i.Key === 3 || i.Key === 4 || i.Key === 5
          || i.Key === 1
        );
      }
      //3 期中复习, 4 期末复习, 5 期末复习公开课, 当前课程所属类型
      this.courseCategoryList = this.allCourseCategoryList.filter(i => i.Key === 3 || i.Key === 4 || i.Key === 5
          || i.Key === courseCategory
        );
      this.model.courseCategory = courseCategory;
      this.loadTimesOfStartTime();
    }
  },
  watch: {
    data: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/signInManage/courseActive.vue